import { createFrontendPlugin, FrontendPlugin, PageBlueprint, ApiBlueprint } from '@backstage/frontend-plugin-api'
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha'
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha'
import { createRouteRef } from '@backstage/core-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
  configApiRef,
} from '@backstage/frontend-plugin-api';

import { pagerDutyApiRef, PagerDutyClient } from './api';
import { isPagerDutyAvailable } from './components';

export const rootRouteRef = createRouteRef({
  id: 'pagerduty',
});

const PagerDutyPage = PageBlueprint.make({
  name: 'PagerDutyPage',
  params: {
    path: '/pagerDuty',
    title: 'PagerDuty',
    routeRef: rootRouteRef,
    loader: () => import('./components/PagerDutyPage').then(m => <m.PagerDutyPage />),
  },
})

const PagerDutyCatalogEntity = EntityCardBlueprint.make({
  name: 'PagerDutyCatalogEntity',
  params: {
    filter: isPagerDutyAvailable,
    loader: () => import('./components/EntityPagerDutyCard').then(m => <m.EntityPagerDutyCard />),
    type: 'info',
  },
})

const HomePagePagerDutyWidget = HomePageWidgetBlueprint.make({
  name: 'HomePagePagerDutyWidget',
  params: {
    title: 'PagerDuty Home Page Widget',
    components: () => import('./components/HomePagePagerDutyCard').then(m => ({ Content: m.Content })),
    settings: {
      schema: {
        title: 'PagerDuty Widget',
        type: 'object',
        properties: {
          integrationKey: {
            title: 'PagerDuty integration key',
            type: 'string',
          },
          serviceId: {
            title: 'PagerDuty service id',
            type: 'string',
          },
          name: {
            title: 'PagerDuty service name',
            type: 'string',
          },
        },
      },
    },
  },
})

const pagerDutyApi = ApiBlueprint.make({
  name: 'pagerduty',
  params: defineParams => defineParams({
    api: pagerDutyApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      configApi: configApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, configApi, fetchApi }) => PagerDutyClient.fromConfig(configApi, { discoveryApi, fetchApi })
  }),
})

const pdPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'pagerduty',
  extensions: [PagerDutyPage, PagerDutyCatalogEntity, HomePagePagerDutyWidget, pagerDutyApi],
})

export default pdPlugin
